import { render, staticRenderFns } from "./qiaoLiangTaiZhang.vue?vue&type=template&id=1852b214&scoped=true"
import script from "./qiaoLiangTaiZhang.vue?vue&type=script&lang=js"
export * from "./qiaoLiangTaiZhang.vue?vue&type=script&lang=js"
import style0 from "./qiaoLiangTaiZhang.vue?vue&type=style&index=0&id=1852b214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1852b214",
  null
  
)

export default component.exports